import { QueryClient } from '@tanstack/react-query';

/**
 * Shared TanStack Query client. Conservative defaults for a government console:
 * short stale time, one retry (the API client already handles 401→refresh), and no
 * refetch-on-focus (avoids surprise reloads mid-task).
 */
export const queryClient = new QueryClient({
  defaultOptions: {
    queries: { staleTime: 30_000, retry: 1, refetchOnWindowFocus: false },
    mutations: { retry: 0 },
  },
});
